import { useVahakMutationQuery } from "hooks/useVahakQueryClient";
import useVahakHttpClient from "hooks/useVahakHttpClient";

// constants
import API from "./const";
import { ApiErrorResponseType } from "custom-types/api-error-response-type";
import { QueryNames } from "./hooks/queryNames";
import { encryptData } from "../methods/encryptData";

export enum LoginScope {
    LOGIN = 0,
    BOS = 1,
    ALT = 2,
    LOAD_VERIFICATION = 3
}
interface SendOTPParams {
    phoneNumber: number | string;
    scope: LoginScope;
    isWhatsApp?: boolean;
}
interface SendOTPResponse {
    data: { message: string };
}

export function useSendOTP() {
    const { POST } = useVahakHttpClient();

    const sendOTP = async ({ phoneNumber, scope, isWhatsApp = false }: SendOTPParams) => {
        const config = {
            key: "bf2f88919c968dc2c50410f26444efe1",
            iv: "c50410f26444efe1"
        };
        const meta = encryptData(
            { phone_number: String(phoneNumber), time_stamp: Date.now(), source: "send_otp" },
            config
        );
        return POST<unknown, SendOTPResponse>(API.OTP, {
            phone_number: String(phoneNumber),
            scope,
            request_meta_data: meta,
            is_whatsapp: isWhatsApp
        });
    };

    return useVahakMutationQuery<SendOTPResponse, ApiErrorResponseType, SendOTPParams>(
        QueryNames.auth.sendOTP,
        sendOTP
    );
}
